/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ passed: NonNullable<unknown>, total: NonNullable<unknown> }} Directory_Agent_Readiness_Checks_VerifiedInputs */

const en_directory_agent_readiness_checks_verified = /** @type {(inputs: Directory_Agent_Readiness_Checks_VerifiedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.passed} of ${i?.total} checks verified`)
};

const zh_directory_agent_readiness_checks_verified = /** @type {(inputs: Directory_Agent_Readiness_Checks_VerifiedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已核验 ${i?.passed}/${i?.total} 项检查`)
};

/**
* | output |
* | --- |
* | "{passed} of {total} checks verified" |
*
* @param {Directory_Agent_Readiness_Checks_VerifiedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_checks_verified = /** @type {((inputs: Directory_Agent_Readiness_Checks_VerifiedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Checks_VerifiedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_checks_verified(inputs)
	return zh_directory_agent_readiness_checks_verified(inputs)
});
export { directory_agent_readiness_checks_verified as "directory.agent_readiness.checks_verified" }